import * as React from "react";
import { SVGProps, memo } from "react";

const SvgWaiting = (props: SVGProps<SVGSVGElement>) => (
  <svg width={17} height={18} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.936 2.144a.937.937 0 0 0-1.123.915l-.625-.003.625.004a.935.935 0 0 0 .935.94.938.938 0 0 0 .188-1.856Zm-2.373.91a2.188 2.188 0 1 1 4.375.018 2.188 2.188 0 0 1-4.375-.019ZM8.748 5.25v-.625.625Z"
      fill="#576375"
    />

    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.75 5.875a.937.937 0 0 0-.938.938v3.125c0 .306.147.578.376.75.157.118.25.303.25.5v4.374a.312.312 0 1 0 .624 0v-4.374c0-.197.093-.382.25-.5a.935.935 0 0 0 .376-.75V6.812a.937.937 0 0 0-.938-.937Zm-2.188.938a2.188 2.188 0 0 1 4.375 0v3.125c0 .596-.239 1.136-.624 1.53v4.095a1.563 1.563 0 0 1-3.126 0v-4.095a2.182 2.182 0 0 1-.625-1.53V6.812ZM2.998 2.144a.937.937 0 0 0-1.123.915l-.625-.003.625.004A.935.935 0 0 0 2.81 4h.001a.938.938 0 0 0 .187-1.856Zm-2.373.91A2.188 2.188 0 1 1 5 3.071a2.188 2.188 0 0 1-4.375-.019ZM2.81 5.25v-.625.625Z"
      fill="#576375"
    />

    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.813 5.875a.937.937 0 0 0-.938.938v3.125c0 .306.146.578.375.75.158.118.25.303.25.5v4.374a.312.312 0 1 0 .625 0v-4.374c0-.197.092-.382.25-.5a.935.935 0 0 0 .375-.75V6.812a.937.937 0 0 0-.938-.937Zm-2.188.938a2.188 2.188 0 0 1 4.375 0v3.125c0 .596-.239 1.136-.625 1.53v4.095a1.563 1.563 0 0 1-3.125 0v-4.095a2.182 2.182 0 0 1-.625-1.53V6.812ZM14.873 2.144a.937.937 0 0 0-1.123.915l-.625-.003.625.004a.933.933 0 0 0 .935.94h.001a.937.937 0 0 0 .187-1.856Zm-2.373.91a2.188 2.188 0 1 1 4.376.018 2.188 2.188 0 0 1-4.376-.019Zm2.185 2.196v-.625.625Z"
      fill="#576375"
    />

    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.688 5.875a.937.937 0 0 0-.938.938v3.125c0 .306.146.578.375.75.158.118.25.303.25.5v4.374a.312.312 0 1 0 .625 0v-4.374c0-.197.092-.382.25-.5a.935.935 0 0 0 .375-.75V6.812a.937.937 0 0 0-.938-.937Zm-2.188.938a2.188 2.188 0 0 1 4.375 0v3.125c0 .596-.239 1.136-.625 1.53v4.095a1.563 1.563 0 0 1-3.125 0v-4.095a2.182 2.182 0 0 1-.625-1.53V6.812Z"
      fill="#576375"
    />
  </svg>
);

const Memo = memo(SvgWaiting);

export default Memo;
